import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * One Vapi phone number — `available` is false when it's on the black list
 * (ai_phone_numbers_blacklist) or while an AI agent instance (ai_agents, status other than
 * 'finished') is dialing from it; unavailable_reason says which, assigned_agent_name who.
 */
export interface AvailablePhoneNumber {
	phone_number_id: string;
	phone_number: string;
	name: string | null;
	available: boolean;
	unavailable_reason: 'blacklisted' | 'in_use' | null;
	blacklist_reason: string | null;
	assigned_agent_id: number | null;
	assigned_agent_name: string | null;
}

@Injectable({
	providedIn: 'root',
})
export class AvailablePhoneNumbersService {
	constructor(private http: HttpClient) {}

	getAvailablePhoneNumbers() {
		const url = `${environment.api}vapi/get_available_phone_numbers/`;
		return this.http.get(url);
	}
}
